import BaseCellHandler from './BaseCellHandler';
import PivotChartWrapper from '@/views/storyboard/charts/pivot/PivotChartWrapper';
import {PivotCellChartData} from 'entities/chartData';

class PivotCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.performSearchQuery;

    renderContent() {
        const {data, queryDuration} = this.state;
        const {chartQuery, chartId, chartTitle, chartSettingsView, onPreviewFooterChange} = this.props;

        if (!Array.isArray(data)) {
            return null;
        }

        return (
            <PivotChartWrapper
                data={data! as PivotCellChartData[]}
                chartId={chartId}
                chartQuery={chartQuery}
                chartTitle={chartTitle}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
                onPreviewFooterChange={onPreviewFooterChange}
            />
        );
    }
}

export default PivotCellHandler;
